/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientIdentifier from './patient-identifier';
import PatientIdentifierDetail from './patient-identifier-detail';
import PatientIdentifierUpdate from './patient-identifier-update';
import PatientIdentifierDeleteDialog from './patient-identifier-delete-dialog';

const PatientIdentifierRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientIdentifier />} />
    <Route path="new" element={<PatientIdentifierUpdate />} />
    <Route path=":id">
      <Route index element={<PatientIdentifierDetail />} />
      <Route path="edit" element={<PatientIdentifierUpdate />} />
      <Route path="delete" element={<PatientIdentifierDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientIdentifierRoutes;
